export default __webpack_public_path__ + "static/media/gallery_09.decd75e9.jpg";